/**
 * Layout constants for the sensor grid panel, and the panel width derived from them.
 *
 * The panel is as tall as its content (`heightFromContent`), so only its width is set here: nine
 * tiles in a 3 x 3 grid beside the events rail. Each tile's height follows from its width.
 */

export const SENSOR_GRID_COLUMNS = 3;
export const SENSOR_GRID_ROWS = 3;
/** `arc.space.2`, matching the `gap={2}` and `padding={2}` the grid renders with. */
const SENSOR_GRID_GAP = 8;
const SENSOR_GRID_PADDING = 8;
/**
 * Preferred tile and rail widths. Kept tight on purpose: the workspace clamps a panel to its
 * container, so a panel that prefers to be wider than the map area is silently shrunk — which is
 * how the rail ended up pushed past the right edge. These add up to a panel that fits CAD's
 * 1024px floor with room for the window chrome.
 */
const SENSOR_GRID_TILE_WIDTH = 190;
export const SENSOR_GRID_RAIL_WIDTH = 300;
/** The rail may shrink under a clamp, but not to the point of being unreadable. */
export const SENSOR_GRID_RAIL_MIN_WIDTH = 240;

export const SENSOR_GRID_PANEL_WIDTH =
    SENSOR_GRID_COLUMNS * SENSOR_GRID_TILE_WIDTH +
    (SENSOR_GRID_COLUMNS - 1) * SENSOR_GRID_GAP +
    SENSOR_GRID_PADDING * 2 +
    SENSOR_GRID_RAIL_WIDTH;
